import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import Spin from 'antd/lib/spin';
import {
  selectTransactions,
  selectFilter,
  selectPagination,
  selectIsLoading,
  fetchTransactionsAction,
} from '../ducks';
import { Transactions } from '../components';
import translate from 'react-i18next/dist/commonjs/translate';
import { mapFilterToEndpointParams } from '../../../common/utils/helpers';

const mapStateToProps = state => ({
  transactions: selectTransactions(state),
  filter: selectFilter(state),
  pagination: selectPagination(state),
  isLoading: selectIsLoading(state),
});

const mapDispatchToProps = dispatch => ({
  actions: bindActionCreators(
    {
      fetchTransactions: fetchTransactionsAction.request
    },
    dispatch
  ),
});

@translate()
@connect(mapStateToProps, mapDispatchToProps)
export default class TransactionsContainer extends Component {
  static propTypes = {
    t: PropTypes.func.isRequired,
    actions: PropTypes.object.isRequired,
    transactions: PropTypes.array.isRequired,
    filter: PropTypes.object.isRequired,
    pagination: PropTypes.object.isRequired,
    isLoading: PropTypes.bool.isRequired,
  };

  componentDidMount() {
    const { actions, filter } = this.props;
    actions.fetchTransactions({filter: mapFilterToEndpointParams(filter)});
  }

  
  handleTableChange = (pagination, filter) => {
    const { actions } = this.props;
    actions.fetchTransactions({
      filter: mapFilterToEndpointParams(filter),
      pagination,
    });
  };

  handleSubmitFilter = (filter) => {
    this.props.actions.fetchTransactions({
      filter: mapFilterToEndpointParams(filter),
    });
  }

  render() {

    const { 
      t,
      transactions,
      filter,
      pagination,
      isLoading
    } = this.props;
    
    return (
      <div>
        <h1>{t('Transakcie')}</h1>
        <Spin spinning={isLoading}>
          <Transactions 
            transactions={transactions}
            filter={filter}
            pagination={pagination}
            onTableChange={this.handleTableChange}
            onSubmitFilter={this.handleSubmitFilter}
            />
        </Spin>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/features/transactions/containers/TransactionsContainer.js